module.exports = __webpack_public_path__ + "media/top/logo_parallel_journal-1ad76162.svg";